const initialState = {
  selectedTopUpTypes: [],
  autoTopUpData: null,
  singleTopUpData: {
    amount: null
  }
}

const ActivationTopUpModule = {
  namespaced: true,
  state: initialState,
  getters: {
    topUpCore (state, getters) {
      if (getters.hasAutoTopUp === false) {
        return null
      }
      if (state.autoTopUpData.type === 'byLimit') {
        return {
          autoTopup: {
            amount: state.autoTopUpData.amount || 0,
            trigger: state.autoTopUpData.trigger || 0,
            type: 'ACCOUNT_BALANCE'
          }
        }
      }
      if (state.autoTopUpData.type === 'monthly') {
        return {
          autoTopup: {
            amount: state.autoTopUpData.amount || 0,
            trigger: state.autoTopUpData.trigger || 2,
            type: 'DAY_OF_MONTH'
          }
        }
      }
      return null
    },
    singleTopUpCore (state, getters) {
      if (getters.hasSingleTopUp === false) {
        return null
      }
      return getters.singleTopUpAmount
    },
    topUp: state => state.autoTopUpData,
    singleTopUpAmount: state => state.singleTopUpData.amount,
    topUpAutoByLimit: (state, getters) => {
      return getters.hasAutoTopUp && state.autoTopUpData?.type === 'byLimit'
    },
    topUpAutoMonthly: (state, getters) => {
      return getters.hasAutoTopUp && state.autoTopUpData?.type === 'monthly'
    },
    singleTopUpData: state => state.singleTopUpData,
    selectedTopUpTypes: state => {
      return state.selectedTopUpTypes
    },
    hasSingleTopUp: state => {
      return state.selectedTopUpTypes.includes('single')
    },
    hasAutoTopUp: state => {
      return state.selectedTopUpTypes.includes('auto')
    },
    hasTopUp: (state, getters) => {
      return getters.hasSingleTopUp || getters.hasAutoTopUp
    },
    withoutTopUp: (state, getters) => {
      return getters.hasTopUp === false
    }
  },
  actions: {
    async storeAllTopUpData ({ commit, dispatch, state, getters, rootGetters }, { selectedTopUpTypes, single, auto, nextStep }) {
      if (selectedTopUpTypes.includes('auto')) {
        commit('storeAutoTopUpData', auto)
      }
      if (selectedTopUpTypes.includes('single')) {
        commit('storeSingleTopUpData', single)
      }
      commit('storeSelection', selectedTopUpTypes)
      commit('activation/goToStep', nextStep, { root: true })
    }
  },
  mutations: {
    setWithoutTopUp (state) {
      state.autoTopUpData.type = 'withoutAuto'
    },
    storeAutoTopUpData (state, autoTopUpData) {
      state.autoTopUpData = autoTopUpData || null
    },
    storeSingleTopUpData (state, amount) {
      state.singleTopUpData.amount = amount
    },
    storeSelection (state, selectedToUpTypes) {
      state.selectedTopUpTypes = [
        ...selectedToUpTypes
      ]
    }
  }
}

export default ActivationTopUpModule
